export default {
    buttons: {
        save: 'Сохранить',
    },
    fields: {
        company_role: {
            label: 'Роль в компании',
            placeholder: 'Выберите роль в компании',
        },
    },
    select: {
        admin: 'ADMIN',
        user: 'USER',
    },
    errors: {
        user_cannot_change_your_role: 'Вы не можете изменить свою роль',
    },
}
